import { ADMIN, CONTROL } from '@rootCommon/constants/common';
import { RISK_RECORD } from '@rootCommon/constants/end-points';
import CrudRequest from '@rootCommon/services/crud-request';
import { RiskRecord } from '@rootTypes/cancerRisk';
import { IdType } from '@rootTypes/common';

class RiskRecordService {
  private getRiskRecord = async (sender: string, organizationId?: IdType): Promise<RiskRecord> => {
    const res = await CrudRequest.get<RiskRecord>(`${RISK_RECORD}/${sender}`, { params: { organizationId } });

    return res.data;
  };

  private updateRiskRecord = async (data: RiskRecord, sender: string, organizationId?: IdType): Promise<RiskRecord> => {
    const res = await CrudRequest.put<RiskRecord, RiskRecord>(
      `${RISK_RECORD}/${sender}`, data, { params: { organizationId } },
    );

    return res.data;
  };

  getAdminRiskRecord = () => this.getRiskRecord(ADMIN);

  getControlRiskRecord = (organizationId: IdType) => this.getRiskRecord(CONTROL, organizationId);

  updateAdminRiskRecord = (data: RiskRecord) => this.updateRiskRecord(data, ADMIN);

  updateControlRiskRecord = (organizationId: IdType, data: RiskRecord) => this.updateRiskRecord(
    data, CONTROL, organizationId,
  );
}

export default new RiskRecordService();
